// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ujMI1O {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: var(--spacing-1);
  cursor: pointer;
  user-select: none;
  border: none;
  box-sizing: border-box;
  padding: 0;
  margin: 0;
  background: transparent;
  height: 16px;
}

.ujMI1O.xyjpl0,
.ujMI1O.aLTgLn {
  cursor: default;
}

.pBpwB7 {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 1px solid var(--radio-border);
  background: var(--radio-bg);
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.e8jwis {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--surface-neutral-white);
}

.gctAue {
  --radio-border: var(--stroke-neutral-dark);
  --label-color: var(--text-neutral-dark);
  --radio-bg: var(--surface-neutral-white);
}

.ujMI1O:not(.naLEPT):not(.xyjpl0):not(.aLTgLn):hover {
  --radio-border: var(--stroke-primary-bright);
}

.naLEPT {
  --radio-border: var(--surface-primary-medium);
  --radio-bg: var(--surface-primary-medium);
}

.xyjpl0 {
  --radio-border: var(--surface-neutral-silver);
  --radio-bg: var(--surface-neutral-white);
  --label-color: var(--text-neutral-strong);
}

.aLTgLn {
  --radio-border: var(--surface-neutral-silver);
  --radio-bg: var(--surface-neutral-white);
  --label-color: var(--text-neutral-dark);
}

.naLEPT.xyjpl0 {
  --radio-border: var(--surface-neutral-silver);
  --radio-bg: var(--surface-neutral-silver);
  --label-color: var(--text-neutral-strong);
}

.naLEPT.aLTgLn {
  --radio-border: var(--surface-neutral-silver);
  --radio-bg: var(--surface-neutral-silver);
  --label-color: var(--text-neutral-dark);
}

.naLEPT.xyjpl0.aLTgLn {
  --radio-border: var(--surface-neutral-silver);
  --radio-bg: var(--surface-neutral-silver);
  --label-color: var(--text-neutral-strong);
}

.jThEoh {
  color: var(--label-color);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-regular);
  font-family: var(--font-family-base);
  text-align: left;
  vertical-align: middle;
  height: 100%;
  display: flex;
  align-items: center;
}
`, "",{"version":3,"sources":["webpack://./../../packages/shared-ui/src/components/RadioInput/RadioInput.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,sBAAsB;EACtB,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,YAAY;AACd;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,2BAA2B;EAC3B,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,0CAA0C;EAC1C,uCAAuC;EACvC,wCAAwC;AAC1C;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,6CAA6C;EAC7C,yCAAyC;AAC3C;;AAEA;EACE,6CAA6C;EAC7C,wCAAwC;EACxC,yCAAyC;AAC3C;;AAEA;EACE,6CAA6C;EAC7C,wCAAwC;EACxC,uCAAuC;AACzC;;AAEA;EACE,6CAA6C;EAC7C,yCAAyC;EACzC,yCAAyC;AAC3C;;AAEA;EACE,6CAA6C;EAC7C,yCAAyC;EACzC,uCAAuC;AACzC;;AAEA;EACE,6CAA6C;EAC7C,yCAAyC;EACzC,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,uCAAuC;EACvC,oCAAoC;EACpC,gBAAgB;EAChB,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB","sourcesContent":[".container {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  gap: var(--spacing-1);\n  cursor: pointer;\n  user-select: none;\n  border: none;\n  box-sizing: border-box;\n  padding: 0;\n  margin: 0;\n  background: transparent;\n  height: 16px;\n}\n\n.container.disabled,\n.container.readOnly {\n  cursor: default;\n}\n\n.radio {\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  border: 1px solid var(--radio-border);\n  background: var(--radio-bg);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: var(--surface-neutral-white);\n}\n\n.default {\n  --radio-border: var(--stroke-neutral-dark);\n  --label-color: var(--text-neutral-dark);\n  --radio-bg: var(--surface-neutral-white);\n}\n\n.container:not(.selected):not(.disabled):not(.readOnly):hover {\n  --radio-border: var(--stroke-primary-bright);\n}\n\n.selected {\n  --radio-border: var(--surface-primary-medium);\n  --radio-bg: var(--surface-primary-medium);\n}\n\n.disabled {\n  --radio-border: var(--surface-neutral-silver);\n  --radio-bg: var(--surface-neutral-white);\n  --label-color: var(--text-neutral-strong);\n}\n\n.readOnly {\n  --radio-border: var(--surface-neutral-silver);\n  --radio-bg: var(--surface-neutral-white);\n  --label-color: var(--text-neutral-dark);\n}\n\n.selected.disabled {\n  --radio-border: var(--surface-neutral-silver);\n  --radio-bg: var(--surface-neutral-silver);\n  --label-color: var(--text-neutral-strong);\n}\n\n.selected.readOnly {\n  --radio-border: var(--surface-neutral-silver);\n  --radio-bg: var(--surface-neutral-silver);\n  --label-color: var(--text-neutral-dark);\n}\n\n.selected.disabled.readOnly {\n  --radio-border: var(--surface-neutral-silver);\n  --radio-bg: var(--surface-neutral-silver);\n  --label-color: var(--text-neutral-strong);\n}\n\n.label {\n  color: var(--label-color);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-regular);\n  font-family: var(--font-family-base);\n  text-align: left;\n  vertical-align: middle;\n  height: 100%;\n  display: flex;\n  align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ujMI1O`,
	"disabled": `xyjpl0`,
	"readOnly": `aLTgLn`,
	"radio": `pBpwB7`,
	"dot": `e8jwis`,
	"default": `gctAue`,
	"selected": `naLEPT`,
	"label": `jThEoh`
};
module.exports = ___CSS_LOADER_EXPORT___;
